<template>
    <div class="compensation-requests-view ob-card" :class="{loading: loading}" style="min-height: 400px;">
        <div v-if="this.qualifies">
            <a v-on:click="openModal"
            href="javascript://void(0)" class="btn btn-md btn-info">
                New Request
            </a>
            <hr />
        </div>

        <modal name="create-request"
            :adaptive="true"
            :scrollable="true"
            height="auto">
            <div class="dashboard-block-white">
                <header>
                    <h3>New Request</h3>
                </header>
                <hr>
                <div class="create-request" :class="{loading: loading}">
                    <form @submit.prevent="createRequest" accept-charset="UTF-8" novalidate="novalidate">
                        <div class="row">
                            <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('type')}">
                                <label for="request-type">Request Type</label>

                                <select name="request-type" id="request-type" v-model="request.type" class="form-control">
                                    <option v-bind:key="type.value" v-for="type in this.requestTypes" :value="type.key">{{ type.value }}</option>
                                </select>

                                <span v-show="errors.has('type')" class="help-block">
                                    {{ errors.first('type') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback col-sm-8 col-md-6" :class="{'has-error': errors.has('request_amount')}">
                                <label for="request-amount" style="margin-left: 40px;">{{ this.request.type === this.TYPE_PRICE_MATCH ? 'Price to Match' : (this.request.type === this.TYPE_REIMBURSEMENT ? 'Reimbursement Amount' : 'Amount') }}</label>

                                <div class="input-group" :class="{'has-error': errors.has('request_amount')}">
                                    <span class="input-group-addon">$</span>

                                    <input id="request-amount"
                                            class="form-control"
                                            min="0"
                                            name="request-amount"
                                            type="number"
                                            v-model="request.request_amount">
                                </div>

                                <span v-show="errors.has('request_amount')" class="help-block" style="margin-left: 40px;">
                                    {{ errors.first('request_amount') }}
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group has-feedback col-sm-8 col-md-5" :class="{'has-error': errors.has('provider_id')}">
                                <label for="request-provider-id">Provider</label>

                                <select name="request-provider-id" id="request-provider-id" v-model="request.provider_id" class="form-control">
                                    <option :value="null">-</option>
                                    <option v-bind:key="provider.id" v-for="provider in this.providers" :value="provider.id">{{ provider.name }}</option>
                                    <option value="Other">Other</option>
                                </select>

                                <span v-show="errors.has('provider_id')" class="help-block">
                                    {{ errors.first('provider_id') }}
                                </span>
                            </div>

                            <div class="form-group has-feedback col-sm-12 col-md-6" v-if="this.request.provider_id === 'Other'" :class="{'has-error': errors.has('provider_other')}">
                                <label for="request-provider-other">Provider Name</label>

                                <input id="request-provider-other"
                                        class="form-control"
                                        name="request-provider-other"
                                        type="text"
                                        v-model="request.provider_other">

                                <span v-show="errors.has('provider_other')" class="help-block">
                                    {{ errors.first('provider_other') }}
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group has-feedback col-sm-12 col-md-12" v-if="this.request.type === this.TYPE_REIMBURSEMENT" :class="{'has-error': errors.has('reimbursement_address')}">
                                <label for="request-reimbursement-address">Full Mailing Address</label>
                                <span
                                    style="font-size: 1.2rem"
                                    class="fa fa-info-circle text-blue"
                                    v-tooltip="'Reimbursement payment is sent directly to the account holder'"
                                ></span>

                                <input id="request-reimbursement-address"
                                        class="form-control"
                                        name="request-reimbursement-address"
                                        type="text"
                                        v-model="request.reimbursement_address">

                                <span v-show="errors.has('reimbursement_address')" class="help-block">
                                    {{ errors.first('reimbursement_address') }}
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group has-feedback col-md-10"
                                :class="{'has-error': errors.has('files')}">
                                <input
                                    id="request-file"
                                    name="request-file"
                                    type="file"
                                    class="form-control"
                                    @change="onFileChange"
                                    onclick="this.value=null;"
                                    style="display:none;">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col" style="border-radius: 5px; border: 1px dotted #919EAB; background-color: #F9FAFB; margin: 15px; padding: 15px 25px;">
                                <span style="margin-bottom: 15px; font-size: 14px;">Please upload a recent invoice showing your expense:</span><br/>
                                <label for="request-file" class="btn btn-sm btn-info" style="margin-bottom: 15px; margin-top: 15px;">
                                    Upload File
                                </label>
                                <br />
                                <span v-if="this.request.type === this.TYPE_PRICE_MATCH && this.request.files.length === 0"><i>* Upload a copy of your latest service bill. (pdf, jpg, png)</i></span>
                                <span v-else-if="this.request.type === this.TYPE_REIMBURSEMENT && this.request.files.length === 0"><i>* Upload a copy of your cancellation or early termination fee from your previous service provider. (pdf, jpg, png)</i></span>
                                <span v-bind:key="index" v-for="(file, index) in this.request.files">
                                    {{ file.name }} &emsp; <a href="javascript://void" @click="removeFile(index)"><b>Remove File</b></a><br />
                                </span>
                            </div>
                        </div>

                        <div
                            class="form-group has-feedback col-md-10"
                            :class="{'has-error': errors.has('files')}">
                            <span
                                v-show="errors.has('files')"
                                class="help-block">
                                {{ errors.first('files') }}
                                </span>
                        </div>

                        <hr>

                        <div v-if="this.request.type === 1">
                            <span>To avoid service disruption it is recommended to cancel your current service following the launch of the Bulk Program.</span>
                            <hr>
                        </div>

                        <div class="row">
                            <div class="col-xs-6">
                                <button type="button" class="btn btn-sm btn-link" @click="resetRequest">
                                    Cancel
                                </button>
                            </div>

                            <div class="col-xs-6 text-right">
                                <button type="submit" class="btn btn-md btn-block btn-success" :disabled="loading">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </modal>
        <div style="max-width: 40em;">
            <ul class="list-group" style="list-style: none;">
                <li style="margin-top: 2em;" v-bind:key="request.display_id" v-for="(request) in this.compensationRequests">
                    <a v-if="request.status === 2" class="pull-right" href="javascript://void" @click="deleteRequest(request.id)"><b>Cancel Request</b></a>
                    <p><b>Request #{{ request.display_id }}</b> <span v-html="request.status_label"></span></p>
                    <span>{{ request.provider }} {{ request.display_type }}: <i><span v-html="request.display_request_cents"></span> Requested</i></span>
                    <br /><span v-if="request.type === 'Reimbursement'">Mail Check To: <i>{{ request.reimbursement_address }}</i></span>
                    <a v-bind:key="file.id" v-for="file in request.files" href="javascript://void" @click="downloadFile(file)" download class="btn-block" style="color: #900C3F;">
                        {{ file.name }}
                    </a>
                    <br />
                    <div v-if="request.status === 1 && request.approved_amount">
                        <b><span v-html="request.display_approved_cents"></span> Approved</b>
                        <br />
                        <span v-if="request.type === 'Reimbursement'">Your reimbursement request has been approved! Payment will be mailed to: <b>{{ request.reimbursement_address }}</b></span>
                        <span v-if="request.type === 'Price Match'">Your price match request has been approved! <span v-if="request.price_lock_date">Your account will be matched until {{ request.price_lock_date }}</span></span>
                    </div>
                    <div v-else-if="request.status === 0 && request.denied_reason">
                        <span><b>Denied:</b> {{ request.denied_reason }}</span>
                    </div>
                    <div v-else-if="request.status === 2">
                        Request submitted! Following review, you will receive an email confirmation at <i>{{ user.email }}</i>.
                    </div>
                    <div v-if="request.type === 'Reimbursement' && request.status !== 0">
                        <br>
                        Reimbursement payment is issued 15-45 days following the launch of the new Bulk Program.
                    </div>
                    <br>
                    <span v-if="request.notes">{{ request.notes }}</span>
                    <hr>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    /**
     * Note: Cannot be nested within a form element with a non-https action
     */
    export default {
        props: {
            afterSave: {
                default: () => {
                    return function(){
                    };
                }
            },

            user: {
                type: Object,
                required: true
            },

            project: {
                type: Object,
                required: true
            },

            resident: {
                type: Object,
                required: false
            },

            compensationRequests: {
                type: Array,
                required: false
            },

            requestTypes: {
                type: Array,
                required: true
            },

            qualifies: {
                type: Boolean,
                required: false
            },
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: false,

                style: {
                    base: {
                        color: '#282828',
                        fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#282828'
                        },
                        lineHeight: '26px',
                        padding: '8px'
                    },

                    invalid: {
                        color: '#C70039',
                        iconColor: '#900C3F'
                    }
                },

                elements: null,
                request: {
                    type: null,
                    request_amount: null,
                    provider_id: null,
                    provider_other: null,
                    reimbursement_address: null,
                    files: [],
                },
                providers: [],

                STATUS_DENIED: 0,
                STATUS_APPROVED: 1,
                STATUS_PENDING: 2,
                TYPE_PRICE_MATCH: 0,
                TYPE_REIMBURSEMENT: 1,
                DENIED_OTHER: 0,
                DENIED_INVALID_DOCUMENT: 1,
                DENIED_INVALID_ADDRESS: 2,
            };
        },

        methods: {
            init(){
                this.loading = true;
                if (this.requestTypes.length === 1) {
                    this.request.type = this.requestTypes[0].key
                }

                return this.loadServiceProviderNames()
                    .then(() => {
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .catch( this.$root.handleErrors );
            },

            loadServiceProviderNames() {
                var url = '/companies/providerNames';

                return axios.get(url)
                    .then((response) => {
                        this.$set( this, 'providers', response.data )
                    });
            },

            onFileChange( e ) {
                if ( e.target.files.length ) {
                    this.request.files.push(e.target.files[0])
                }
            },

            removeFile( index ) {
                this.request.files.splice(index, 1)
            },

            openModal() {
                this.$modal.show( 'create-request' )
            },

            resetRequest() {
                this.$modal.hide( 'create-request' )
                this.request = {
                    type: null,
                    request_amount: null,
                    provider_id: null,
                    provider_other: null,
                    files: [],
                };
                if (this.requestTypes.length === 1) {
                    this.request.type = this.requestTypes[0].key
                }
                this.errors.clear()
            },

            deleteRequest(id) {
                var url = '/requests/' + id;
                return axios.delete(url)
                    .then((response) => {
                        window.location.href = "/requests";
                    })
            },

            downloadFile(file) {
                window.location.href = '/files/' + file.id + '/download';
            },

            createRequest() {
                this.loading = true;
                this.errors.clear();

                var url = '/requests';
                var formData = new FormData();
                formData.append('type', this.request.type);
                formData.append('request_amount', this.request.request_amount);
                formData.append('provider_id', this.request.provider_id);
                formData.append('provider_other', this.request.provider_other);
                formData.append('reimbursement_address', this.request.reimbursement_address);
                for(let i in this.request.files) {
                    formData.append('files[' + i + ']', this.request.files[i]);
                }

                return axios.post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then((response) => {
                        if ( response.data.errors ) {
                            for (const [key, value] of Object.entries(response.data.errors)) {
                                this.errors.add({
                                    field: key,
                                    msg: value[0]
                                });
                            }
                        } else if ( response.data.error ) {
                            this.$notify( {
                                type: 'danger',
                                placement: 'top-left',
                                title: response.data.error,
                            } );
                        } else {
                            this.resetRequest();
                            this.$notify( {
                                type: 'success',
                                placement: 'top-left',
                                title: 'Request Submitted',
                            } );
                            window.location.href = "/requests";
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    .catch( this.$root.handleErrors );
            }
        }
    }
</script>
